var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 2.21568V19.9945H9.16667V14.5693C9.16667 13.1215 8.10556 11.829 6.66111 11.6903C5.00556 11.5294 3.61111 12.8275 3.61111 14.4528V20H1.11111C0.5 20 0 19.5008 0 18.8906V6.52031C0 5.15015 0.822222 3.93531 2.09444 3.43052L8.61667 0.157672C9.30556 -0.114141 10.0778 -0.0309328 10.6889 0.37956C11.3 0.7956 11.6667 1.47791 11.6667 2.21568Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 9.38824V18.885C20.0001 19.4952 19.5001 19.9945 18.8889 19.9945H16.6667V15.6233C16.6667 15.0686 16.2945 14.5527 15.7445 14.4639C15.0501 14.3474 14.4445 14.8855 14.4445 15.5567V19.9945H12.7778V5.57177C12.7778 5.21675 12.9501 4.87837 13.2389 4.67313C13.5278 4.46233 13.9001 4.40686 14.2389 4.5178L17.7223 6.23189C19.0834 6.68676 20.0001 7.95707 20.0001 9.38824Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyBuilding);
export default __webpack_public_path__ + "static/media/company_building.46a57cbaa28cefb05972228e59585c5e.svg";
export { ForwardRef as ReactComponent };